/**
The main entry point for Contact App.

Referenced by page.help-center.liquid templates.
* */
import React from 'react';
import ReactDOM from 'react-dom';
import HelpCenter from './apps/pages/help-center';
import OVApp from './utils/OVContext';
import { jsx as _jsx } from "react/jsx-runtime";
ReactDOM.render( /*#__PURE__*/_jsx(OVApp, {
  children: /*#__PURE__*/_jsx(HelpCenter, {})
}), document.getElementById('help-center'));